const client = [{
  desc: '网路切换-旧版本',
  options: {
    url: '/Config/GetConfig',
    method: 'post',
    baseURL: '/cxv3'
  },
  vuex: false
}, {
  desc: '切换网络的日志',
  options: {
    url: '/Log/ExchangeLog',
    method: 'post',
    baseURL: '/cxv3'
  },
  vuex: false
}, {
  desc: '记录切换网络日志',
  options: {
    url: '/Log/CheckOnLine',
    method: 'post',
    baseURL: '/cxv3'
  },
  vuex: false
}, {
  desc: '网路切换-新版本730',
  options: {
    url: '/config/getProxyConfig',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    formdata: true // 是否通过formdata的方式传参
  },
  vuex: false
}]
export default client



// WEBPACK FOOTER //
// ./src/api/client.js